module.exports = __webpack_public_path__ + "img/docs.cbf4f7c0.webp";